import { getTranslations } from '../../../../navigation/navigation-translations';
import {
    parseConfig,
    checkCountryVisibility,
    GLOBAL_REGION_ID
} from './utils';
import { useEnvConfig } from '@config/env/env-config-provider';
import { QueryParams } from '@config/react-router-dom/hooks/query-params.types';
import { useQueryParams } from '@config/react-router-dom/hooks/use-query-params';
import { ActivityTypePaths, HeaderSections, NavigationProps } from '@containers/navigation/navigation-types';

export const useNewCoursesNavigationProps = (): NavigationProps => {
    const { NEW_COURSES_VISIBILITY } = useEnvConfig();
    const { NEW_COURSES } = getTranslations();
    const { regionIds: visibleRegionIds = [], countryCodes: visibleCountryCodes = [] } = parseConfig(NEW_COURSES_VISIBILITY);
    const getCountryVisibility = (countryCode: string | null) => {
        return checkCountryVisibility(countryCode, visibleCountryCodes);
    };
    const countryCode = useQueryParams()?.get(QueryParams.countryCode);
    const isVisibleGlobally = visibleRegionIds.includes(GLOBAL_REGION_ID);
    const isNewCoursesVisible = isVisibleGlobally || getCountryVisibility(countryCode);

    return {
        label: NEW_COURSES,
        id: 'new-courses',
        isHidden: !isNewCoursesVisible,
        isNew: false,
        isDefault: false,
        path: ActivityTypePaths.newCourses,
        portalId: null,
        isNewCoursesVisible,
        headerSection: HeaderSections.LEARN
    };
};
